import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import produce, { immerable } from 'immer';
import { Map } from 'immutable';

import { HistoryItemEntity } from './history-item.entity';

export type IHistoryListExtra = IListColumnConfig<HistoryItemEntity>;

interface ISubscriptionListEntity extends IListAttrs<HistoryItemEntity> {
	availableColumns: Map<string, IHistoryListExtra>;
}

const entityDefaults: ISubscriptionListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class HistoryListEntity
	implements
		ISubscriptionListEntity,
		IListOperations<HistoryListEntity, HistoryItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IHistoryListExtra>
	): HistoryListEntity {
		const instance = new HistoryListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IHistoryListExtra]>());

		instance.availableColumns = Map(cols);
		return instance;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<HistoryItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(elems: Map<string, HistoryItemEntity>): HistoryListEntity {
		return produce(this, (draft: HistoryListEntity) => {
			draft.elements = elems;
		});
	}
}
